import { PublicApplicationData } from '@flatsy/types/Applications'

/**
 * @description
 * @param {string | string[] | null} fallback
 * @param {PublicApplicationData} application
 * @returns string | undefined
 */
export const getApplicationAgentIdOr = (
  fallback: string | string[] | null,
  application: PublicApplicationData
): string | undefined => {
  if (application && application.agent_id) {
    return application.agent_id
  }
  if (!fallback) {
    return undefined
  }
  if (typeof fallback === 'string') {
    return fallback
  }

  if (typeof fallback === 'object') {
    return fallback.join('')
  }
}
